export default [
	{"pattern": /tesl(\w+)/g, "map_to": "test$1"},
	{"pattern": "c4", "map_to": "ca"}
]
